import { isMobile as isMobileLib, isTablet as isTabletLib, isIPad13 } from 'react-device-detect';

export const isTablet = isTabletLib || isIPad13;
export const isMobile = isMobileLib && !isTablet;
